export const getObjectKeys = Object.keys as <T>(
  o: T
) => Extract<keyof T, string | number>[];

export function sortByKey<T>(
  arr: T[],
  key: keyof T,
  order: "asc" | "desc" = "asc"
): T[] {
  return arr.sort((a, b) => {
    const valA = String(a[key] || "").toLowerCase();
    const valB = String(b[key] || "").toLowerCase();
    const comparison = valA.localeCompare(valB);
    return order === "desc" ? -comparison : comparison;
  });
}
